// export const BASEURL = 'http://172.16.1.157:3000/api/'; // kashif
export const BASEURL = 'https://devbackend.agentzena.com/api/admin/'; // development
// export const BASEURL = 'https://backend.ormeagent.com/api/'; // production
